<div class="tw-flex tw-gap-3 tw-flex-wrap">
  <div
    *ngIf="data?.consumed"
    class="energy-card tw-min-w-40 consumed">
    <div class="energy-card-title-container">
      <mat-icon svgIcon="block_home"></mat-icon>
      <div class="energy-card-title">{{ labels.consumedTitle }}</div>
    </div>
    <div class="tw-min-h-8">
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label">{{ labels.min }}</div>
      <div class="energy-card-value">{{ data?.consumed?.min | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{labels.max }} </div>
      <div class="energy-card-value">{{ data?.consumed?.max | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label"> {{ labels.avg }} </div>
      <div class="energy-card-value">{{ data?.consumed?.avg | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{ labels.total }} </div>
      <div class="energy-card-value">{{ data?.consumed?.total | number:'1.0-2' : locate }}</div>
    </div>
  </div>
  <div
    *ngIf="data?.generated"
    class="energy-card tw-min-w-40  produced">
    <div class="energy-card-title-container">
      <mat-icon svgIcon="block_solar"></mat-icon>
      <div class="energy-card-title"> {{ labels.generatedTitle }} </div>
    </div>
    <div class="tw-min-h-8">
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label">{{ labels.min }}</div>
      <div class="energy-card-value">{{ data?.generated?.min | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{labels.max }} </div>
      <div class="energy-card-value">{{ data?.generated?.max | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label"> {{ labels.avg }} </div>
      <div class="energy-card-value">{{ data?.generated?.avg | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{ labels.total }} </div>
      <div class="energy-card-value">{{ data?.generated?.total | number:'1.0-2' : locate }}</div>
    </div>
  </div>
  <div
    *ngIf="data?.irradiation"
    class="energy-card tw-min-w-40 irradiation">
    <div class="energy-card-title-container">
      <mat-icon svgIcon="block_irradiance"></mat-icon>
      <div class="energy-card-title">{{ labels.irradiationTitle }}</div>
    </div>
    <div class="tw-min-h-8">
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label">{{ labels.min }}</div>
      <div class="energy-card-value">{{ data?.irradiation?.min | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{labels.max }} </div>
      <div class="energy-card-value">{{ data?.irradiation?.max | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row white">
      <div class="energy-card-label"> {{ labels.avg }} </div>
      <div class="energy-card-value">{{ data?.irradiation?.avg | number:'1.0-2' : locate }}</div>
    </div>
    <div class="energy-card-row">
      <div class="energy-card-label"> {{ labels.total }} </div>
      <div class="energy-card-value">{{ data?.irradiation?.total | number:'1.0-2' : locate }}</div>
    </div>
  </div>
  <div
    *ngIf="data?.grid"
    class="energy-card tw-min-w-80 grid">
    <div class="energy-card-title-container">
      <mat-icon svgIcon="block_grid"></mat-icon>
      <div class="energy-card-title"> {{ labels.gridTitle }} </div>
    </div>
    <div class="tw-flex tw-gap-2">
      <div class="tw-w-full">
        <div class="tw-min-h-8 energy-card-subtitle">
          {{ labels.importSubtitle }}
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label">{{ labels.min }}</div>
          <div class="energy-card-value">{{ data?.grid?.import?.min | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{labels.max }} </div>
          <div class="energy-card-value">{{ data?.grid?.import?.max | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label"> {{ labels.avg }} </div>
          <div class="energy-card-value">{{ data?.grid?.import?.avg | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{ labels.total }} </div>
          <div class="energy-card-value">{{ data?.grid?.import?.total | number:'1.0-2' : locate }}</div>
        </div>
      </div>
      <div class="tw-w-full tw-gap-2">
        <div class="tw-min-h-8 energy-card-subtitle">
          {{ labels.exportSubtitle }}
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label">{{ labels.min }}</div>
          <div class="energy-card-value">{{ data?.grid?.export?.min | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{labels.max }} </div>
          <div class="energy-card-value">{{ data?.grid?.export?.max | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label"> {{ labels.avg }} </div>
          <div class="energy-card-value">{{ data?.grid?.export?.avg | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{ labels.total }} </div>
          <div class="energy-card-value">{{ data?.grid?.export?.total | number:'1.0-2' : locate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="data?.battery"
    class="energy-card tw-min-w-80 battery">
    <div class="energy-card-title-container">
      <mat-icon svgIcon="block_battery"></mat-icon>
      <div class="energy-card-title"> {{ labels.batteryTitle }} </div>
    </div>
    <div class="tw-flex tw-gap-2">
      <div class="tw-w-full">
        <div class="tw-min-h-8 energy-card-subtitle">
          {{ labels.chargeSubtitle }}
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label">{{ labels.min }}</div>
          <div class="energy-card-value">{{ data?.battery?.charged?.min | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{labels.max }} </div>
          <div class="energy-card-value">{{ data?.battery?.charged?.max | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label"> {{ labels.avg }} </div>
          <div class="energy-card-value">{{ data?.battery?.charged?.avg | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{ labels.total }} </div>
          <div class="energy-card-value">{{ data?.battery?.charged?.total | number:'1.0-2' : locate }}</div>
        </div>
      </div>
      <div class="tw-w-full tw-gap-2">
        <div class="tw-min-h-8 energy-card-subtitle">
          {{ labels.dischargeSubtitle }}
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label">{{ labels.min }}</div>
          <div class="energy-card-value">{{ data?.battery?.discharged?.min | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{labels.max }} </div>
          <div class="energy-card-value">{{ data?.battery?.discharged?.max | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row white">
          <div class="energy-card-label"> {{ labels.avg }} </div>
          <div class="energy-card-value">{{ data?.battery?.discharged?.avg | number:'1.0-2' : locate }}</div>
        </div>
        <div class="energy-card-row">
          <div class="energy-card-label"> {{ labels.total }} </div>
          <div class="energy-card-value">{{ data?.battery?.discharged?.total | number:'1.0-2' : locate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>